// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs--tabs--adf2b8"};